import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Avatar, Button, Col, Popover, Row, Tag } from "antd";
import { RcbLogoutButton } from "./rcb-logout-button.js";
import { useTranslation } from "../../../others/i18n.js";
import { spacing } from "../../../styles/spacing.js";
const RcbAvatar = ({ user, showLogout = false, imageSize = 48, title, placement })=>{
    const { t } = useTranslation();
    const profileRowColStyle = {
        textAlign: "center",
        flex: 1,
        minWidth: "10rem",
        paddingBottom: spacing.layout.content.paddingSmall
    };
    const spaceStyle = {
        flex: "1"
    };
    return /*#__PURE__*/ _jsx(Popover, {
        title: title || t("User information"),
        placement: placement || "bottomRight",
        content: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    style: {
                        ...profileRowColStyle,
                        textAlign: "left"
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Col, {
                            children: /*#__PURE__*/ _jsx("b", {
                                children: `${user?.firstName} ${user?.lastName}`
                            })
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            style: spaceStyle
                        }),
                        /*#__PURE__*/ _jsx(Col, {
                            children: /*#__PURE__*/ _jsx(Tag, {
                                color: "blue",
                                children: user?.role
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Row, {
                    children: /*#__PURE__*/ _jsx(Col, {
                        children: /*#__PURE__*/ _jsx(Button, {
                            type: "link",
                            href: `mailto:${user?.email}`,
                            style: {
                                padding: "0px"
                            },
                            children: `${user?.email}`
                        })
                    })
                }),
                /*#__PURE__*/ _jsx(Row, {
                    hidden: !showLogout,
                    children: /*#__PURE__*/ _jsx(Col, {
                        style: {
                            ...profileRowColStyle,
                            paddingTop: spacing.layout.content.padding
                        },
                        children: /*#__PURE__*/ _jsx(RcbLogoutButton, {})
                    })
                })
            ]
        }),
        children: /*#__PURE__*/ _jsx(Avatar, {
            size: imageSize,
            shape: "circle",
            src: `https://www.gravatar.com/avatar/${user?.emailMd5}?d=mp&size=${imageSize}`,
            style: {
                borderRadius: "50%",
                borderColor: "#1890ff",
                borderWidth: `${Math.floor(imageSize / 16)}px`,
                borderStyle: "solid"
            },
            alt: `Image of ${user?.firstName} ${user?.lastName}`
        })
    });
};
export { RcbAvatar };
